export default function () {
  return {
    cartDetail: {},
    cartNumber: null,
    loading: true,
    currentOrderParameters: {
      orderNumber: null,
      paymentMethodId: null,
      orderFulfillments: [],
      tipAmount: null,
      isAcknowledgeAccepted: false,
      isGiftCardAllowForRecurringOrder: false,
      isAcknowledgedForDelivery: false,
    },
    checkoutInReviewMode: false,
    substituteDetail: {},
    recentSubstituteDetail: {},
    alertDetail: {},
    outOfStockProducts: {},
    shippingRates: {},
    alertData: {},
    allowPlaceOrder: true,
    isTipConfirmed: false,
    checkoutSelection: null,
    isConfirmSubscription: false,
    payAtStore: false,
    deliveryPartners: {},
    rateLoader: false,
  }
}
